import * as React from 'react';
import {AppProvider} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';

import {Link} from '../Link';

import {Translations} from './Translations';

interface Props {
  children?: React.ReactNode;
}

export function Polaris({children}: Props) {
  const [i18n] = useI18n({
    id: 'Polaris',
    translations: (code) => {
      return Translations[code] ?? Translations.en;
    },
  });

  return (
    <AppProvider
      i18n={i18n.translations}
      linkComponent={Link}
      features={{
        polarisSummerEditions2023: true,
      }}
    >
      {children}
    </AppProvider>
  );
}
